<script setup lang="ts">
import {Avatar, Button} from "@/Components/Library";
import {Icon} from "@iconify/vue";

const props = defineProps<{contact: any}>();
const emit = defineEmits<{select: any}>();
</script>
<template>
    <button
        class="flex cursor-pointer items-center gap-2 rounded-md border bg-stone-50 p-2 text-xs text-stone-700 shadow-sm transition dark:border-stone-800 dark:bg-stone-900 dark:text-stone-300"
        @click="emit('select', contact)"
    >
        <Avatar
            :user="contact"
            class="flex h-7 w-7 shrink-0 text-xs"
            :class="[
                `bg-${contact.profile?.color?.class ?? 'stone-300'}`,
                contact.profile?.color?.class === 'white' ? 'text-black' : 'text-white',
            ]"
            shape="circle"
        />
        <div>
            <span class="font-medium">{{ contact.first_name }}</span>
            <span>&nbsp;</span>
            <span class="font-bold">{{ contact.last_name }}</span>
        </div>
        <div class="ml-auto text-stone-500">
            <Icon
                :icon="
                    contact.preferences.allow_adding_to_groups
                        ? 'streamline:user-add-plus'
                        : 'material-symbols:mail-outline'
                "
                width="20"
            />
        </div>
    </button>
</template>
<style scoped></style>
